export enum ReportTypeLabels {
  Requests = 'Requests',
  DataDisputes = 'Data Disputes',
  Dashboard = 'Dashboard',
  VerificationRequests = 'Verification Requests',
  UploadsLog = 'Uploads Log',
}
